import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 1,
  class: "column-cell",
  style: {"color":"var(--error-color)"}
}
const _hoisted_4 = {
  key: 1,
  class: "column-cell"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TreeTable = _resolveComponent("TreeTable")!
  const _component_FieldGroupForm = _resolveComponent("FieldGroupForm")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TreeTable, {
      value: _ctx.nodes,
      loading: _ctx.loading,
      autoLayout: true,
      columnResizeMode: "fit",
      scrollable: true,
      scrollHeight: "flex",
      filters: _ctx.filters,
      filterMode: _ctx.filterMode.value,
      expandedKeys: _ctx.expandedRows
    }, {
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.NoEntriesFound', { entryName: _ctx.$t('Squeeze.MasterData.Data') })), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "name",
          header: _ctx.$t('Squeeze.System.Name'),
          expander: "",
          style: {"min-width":"7rem"}
        }, {
          body: _withCtx((slotProps) => [
            (_ctx.showSkeleton)
              ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
              : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(slotProps.node.data.name), 1))
          ]),
          filter: _withCtx(() => [
            _createVNode(_component_InputText, {
              modelValue: _ctx.filters['name'],
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters['name']) = $event)),
              type: "text",
              class: "p-column-filter filter-field",
              style: {"min-width":"100%"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "type",
          header: _ctx.$t('Squeeze.System.Type'),
          style: {"min-width":"7rem"}
        }, {
          body: _withCtx((slotProps) => [
            (_ctx.showSkeleton)
              ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(slotProps.node.data.type), 1))
          ]),
          filter: _withCtx(() => [
            _createVNode(_component_InputText, {
              modelValue: _ctx.filters['type'],
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters['type']) = $event)),
              type: "text",
              class: "p-column-filter filter-field",
              style: {"min-width":"100%"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "message",
          header: _ctx.$t('PrimeVue.Message'),
          style: {"min-width":"7rem"}
        }, {
          body: _withCtx((slotProps) => [
            (_ctx.showSkeleton)
              ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
              : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createTextVNode(_toDisplayString(slotProps.node.data.message), 1)
                ])), [
                  [
                    _directive_tooltip,
                    slotProps.node.data.message,
                    void 0,
                    { bottom: true }
                  ]
                ])
          ]),
          filter: _withCtx(() => [
            _createVNode(_component_InputText, {
              modelValue: _ctx.filters['message'],
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters['message']) = $event)),
              type: "text",
              class: "p-column-filter filter-field",
              style: {"min-width":"100%"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "status",
          header: _ctx.$t('Squeeze.System.Status'),
          style: {"min-width":"5rem","max-width":"7rem"}
        }, {
          body: _withCtx((slotProps) => [
            (_ctx.showSkeleton)
              ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (slotProps.node.data.status === 'success')
                    ? (_openBlock(), _createBlock(_component_Tag, {
                        key: 0,
                        severity: "success",
                        value: _ctx.$t('Squeeze.General.Success')
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true),
                  (slotProps.node.data.status === 'info')
                    ? (_openBlock(), _createBlock(_component_Tag, {
                        key: 1,
                        severity: "info",
                        value: _ctx.$t('Squeeze.General.Info')
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true),
                  (slotProps.node.data.status === 'warning')
                    ? (_openBlock(), _createBlock(_component_Tag, {
                        key: 2,
                        severity: "warning",
                        value: _ctx.$t('Squeeze.General.Warning')
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true),
                  (slotProps.node.data.status === 'error')
                    ? (_openBlock(), _createBlock(_component_Tag, {
                        key: 3,
                        severity: "danger",
                        value: _ctx.$t('Squeeze.General.Error')
                      }, null, 8, ["value"]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          filter: _withCtx(() => [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.filters['status'],
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters['status']) = $event)),
              options: _ctx.statusTypes,
              class: "p-column-filter filter-field",
              placeholder: "",
              style: {"height":"2.111rem","min-width":"100%"},
              showClear: true
            }, {
              value: _withCtx((slotProps) => [
                (slotProps.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("Squeeze.General." + slotProps.value.charAt(0).toUpperCase() + slotProps.value.slice(1))), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(slotProps.placeholder), 1))
              ]),
              option: _withCtx((slotProps) => [
                _createElementVNode("span", {
                  class: _normalizeClass('status-badge ' + slotProps.option)
                }, _toDisplayString(_ctx.$t("Squeeze.General." + slotProps.option.charAt(0).toUpperCase() + slotProps.option.slice(1))), 3)
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          class: "buttonColumn",
          style: {"min-width":"8rem","max-width":"8rem"}
        }, {
          body: _withCtx((slotProps) => [
            (_ctx.showSkeleton)
              ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
              : (!_ctx.showSkeleton && slotProps.node.data.status && slotProps.node.data.message)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives(_createVNode(_component_Button, {
                      disabled: slotProps.node.data.status === 'success',
                      icon: "mdi mdi-skip-next-outline",
                      class: "p-button-lg p-button-rounded p-button-danger p-button-text",
                      onClick: ($event: any) => (_ctx.openSkipDialog(slotProps.node))
                    }, null, 8, ["disabled", "onClick"]), [
                      [_directive_tooltip, _ctx.$t('Squeeze.General.Skip')]
                    ]),
                    _withDirectives(_createVNode(_component_Button, {
                      disabled: slotProps.node.data.status === 'success',
                      icon: "mdi mdi-pencil-outline",
                      class: "p-button-lg p-button-rounded p-button-success p-button-text",
                      onClick: ($event: any) => (_ctx.openEditDialog(slotProps.node))
                    }, null, 8, ["disabled", "onClick"]), [
                      [_directive_tooltip, _ctx.$t('Squeeze.General.Customize')]
                    ])
                  ], 64))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "loading", "filters", "filterMode", "expandedKeys"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.editDialog,
      onOnClose: _ctx.onCloseForm,
      onOnConfirm: _ctx.onSaveForm,
      headerText: _ctx.headerText,
      showKeepDialogOpen: false
    }, {
      content: _withCtx(() => [
        _createVNode(_component_FieldGroupForm, {
          fieldEntry: _ctx.rowData,
          showErrorMessage: _ctx.showErrorMessage,
          onUpdate: _ctx.onUpdate
        }, null, 8, ["fieldEntry", "showErrorMessage", "onUpdate"])
      ]),
      _: 1
    }, 8, ["show", "onOnClose", "onOnConfirm", "headerText"])
  ], 64))
}